import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, type ButtonProps } from './Button';

export interface ApprovalRequestButtonProps extends Omit<ButtonProps, 'children'> {
  children?: ReactNode;
}

/**
 * Surfaces server-driven approval when the BE returns `approval_required`.
 * Keep visible; do not hide money-moving actions based on role alone.
 */
export function ApprovalRequestButton({ children, ...rest }: ApprovalRequestButtonProps) {
  const { t } = useTranslation('common');
  return (
    <Button type="button" variant="secondary" {...rest}>
      {children ?? t('ui.approvalRequest')}
    </Button>
  );
}
